import React, { useEffect, useState } from "react";
import { trackPromise } from "react-promise-tracker";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";
import axios from "../../../axios/AxiosInterceptors";
import { onError, onSuccess } from "../../../store/actions/popupActions";
import useStyles from "../../../Styles";
import MeterAccountComponent from "./MeterAccountComponent";

const ViewMeterAccount = (props) => {

    const classes = useStyles(props);
    const dispatch = useDispatch();
    const history = useHistory();
    const params = useParams();
    const [meterAccount, setMeterAccount] = useState({});

    useEffect(() => {
        retrieveMeterAccount();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params])

    const retrieveMeterAccount = async () => {
        await trackPromise(axios.get("/powermeter/v1/account/" + params.accountId + "/meter/" + params.meterAccountId).then(response => {
            setMeterAccount({ ...response.data });
        })).catch(error => {
            dispatch(onError(error.response));
        })
    }

    const onUpdate = (meterAccount) => {
        setMeterAccount({ ...meterAccount });
    }

    const updateAccount = async (accountId, meterAccountId, meterAccount) => {
        await trackPromise(axios.put("/powermeter/v1/account/" + accountId + "/meter/" + params.meterAccountId, JSON.stringify(meterAccount)).then(response => {
            dispatch(onSuccess("Meter Account updated successfully"));
            history.push("/meter-reading/account/" + accountId + "/meter-account");
        })).catch(error => {
            dispatch(onError(error.response));
        })
    }

    return (
        <main className={classes.layout}>
            <MeterAccountComponent meterAccount={meterAccount} onChange={onUpdate} saveMeterAccount={updateAccount} />
        </main>
    )
}

export default ViewMeterAccount;